export default __webpack_public_path__ + "static/media/ruang-ilmiah.1a79be79.png";